<template>
  <v-container>
    <v-alert class="text-center" shaped dense dark color="#f1a300">
      <span style="color: #142638"
        ><strong>
          Bienvenido al sistema de gestiones TIC ante la SAT, puedes realizar declaraciones
          dando click sobre el menu del icono
        </strong>
      </span>
      <v-icon>all_inbox</v-icon>
    </v-alert>
    <v-hover v-slot="{ hover }">
      <v-card :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }" class="d-flex justify-content-center">
        <v-img :src="require('@/assets/logo2.jpg')" width="100%" height="90vh"  >

        </v-img>
      </v-card>
    </v-hover>
  </v-container>
</template>
<script>
import logo_back from "@/assets/fondo_mantenimiento.png";
export default {
  data() {
    return {
      logo_back,
    };
  },
};
</script>

<style scoped>
.v-card {
  transition: opacity 0.4s ease-in-out;
}

.v-card:not(.on-hover) {
  opacity: 0.6;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
</style>